import LoginModule from './modules/login/login.module';
import * as storeTypes from './auth.store-types';
import axios from 'axios';
import {CurrentUser} from './models/current-user';

export default {
    namespaced: true,
    state: {
        currentUser: new CurrentUser,
        isAuthChecked: false,
    },
    mutations: {
        [storeTypes.SET_CURRENT_USER]: (state, currentUser) => state.currentUser = currentUser,
        [storeTypes.SET_IS_AUTH_CHECKED]: (state, isAuthChecked) => state.isAuthChecked = isAuthChecked,
    },
    actions: {
        [storeTypes.ACTION_CHECK_AUTH](store) {
            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success, error, user}} = await axios.post('/api/auth/check');

                        if (success) {
                            store.commit(storeTypes.SET_CURRENT_USER, CurrentUser.fromArray(user));
                            store.commit(storeTypes.SET_IS_AUTH_CHECKED, true);
                            return resolve();
                        }

                        reject(error);
                    } catch (error) {
                        reject(error);
                    } finally {
                        //
                    }
                })();
            });
        },
        [storeTypes.ACTION_LOGOUT](store) {
            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.post('/api/auth/logout');

                        if (success) {
                            store.commit(storeTypes.SET_CURRENT_USER, new CurrentUser);
                            store.commit(storeTypes.SET_IS_AUTH_CHECKED, false)
                            return resolve();
                        }
                    } catch (error) {
                        reject(error);
                    }
                })();
            });
        },
    },
    getters: {
        [storeTypes.GET_CURRENT_USER]: state => state.currentUser,
        [storeTypes.GET_IS_AUTH_CHECKED]: state => state.isAuthChecked,
    },
    modules: {
        login: LoginModule,
    },
}